import { render, staticRenderFns } from "./StudentCommunicationPage.vue?vue&type=template&id=ba94799e&"
import script from "./StudentCommunicationPage.vue?vue&type=script&lang=ts&"
export * from "./StudentCommunicationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports